import { useTranslation } from 'react-i18next';
import { Form, Layout, Tabs, TabsProps } from "antd";

import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import React, { ChangeEvent, useState, KeyboardEvent, useEffect } from "react";
import FilterAppraisalPlan from "./components/filter-appraisal-plan/FilterAppraisalPlan";
import TableWaitAppraisalPlan from "./components/table-appraisal-plan/TableWaitAppraisalPlan";
import TableAppraisalPlan from "./components/table-appraisal-plan/TableAppraisalPlan";
import {
  CourseApprovalType,
  FilterDateCoursePlan,
} from "../../../types/course-plan-approval";
import { useAuthStore } from "../../../stores/stores";
import { isEmpty } from "lodash";
import { postCoursePlanSearchAppraisal } from "../../../service/course-plan-managment/mooc-approval-plan/mooc-approval-plan-api";
import ManyApprovalsSurvey from "./components/many-approvals/ManyApprovals";
import { ManyCoursePlanArroval } from "../../../types/course-plan-managment/mooc-approval";
import { useLocation } from "react-router-dom";
type ContentConstructionProps = {
  title?: string;
};
const AppraisalPlanList = (props: ContentConstructionProps) => {
  const { t } = useTranslation();
  const { title } = props;
  const location = useLocation();
  const [isOpenManyApprovalsSurvey, setIsOpenManyApprovalsSurvey] =
    useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const userId = useAuthStore((state) => state.user?.id);
  const [activeTabKey, setActiveTabKey] = useState<string>(
    location?.state?.keyTab ?? "1"
  );
  const [searchValue, setSearchValue] = useState<string>("");
  const [searchValueNotFound, setSearchValueNotFound] = useState<string>("");
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [listCourse, setListCourse] = useState<CourseApprovalType[]>([]);
  const [listCourseApproval, setListCourseApproval] = useState<
    CourseApprovalType[]
  >([]);
  const [listCourseMany, setListCourseMany] = useState<ManyCoursePlanArroval[]>(
    []
  );
  const [totalRecordsSubmit, setTotalRecordsSubmit] = useState<number>(0);
  const [totalRecordsApprove, setTotalRecordsApprove] = useState<number>(0);
  const [form] = Form.useForm();
  const [filterData, setFilterData] = useState<FilterDateCoursePlan>({
    submissionDate: null,
    approvalDate: null,
  });
  const getData = (type: boolean) => {
    const data = {
      keyword: searchValue,
      pageNumber: pageNumber,
      pageSize: pageSize,
      individualId: userId,
      submitedDateFrom: !isEmpty(filterData.submissionDate?.[0])
        ? new Date(filterData.submissionDate?.[0]).toISOString()
        : "",
      submitedDateTo: !isEmpty(filterData.submissionDate?.[1])
        ? new Date(filterData.submissionDate?.[1]).toISOString()
        : "",
      approvalDateFrom: type
        ? !isEmpty(filterData.approvalDate?.[0])
          ? new Date(filterData.approvalDate?.[0]).toISOString()
          : ""
        : null,
      approvalDateTo: type
        ? !isEmpty(filterData.approvalDate?.[1])
          ? new Date(filterData.approvalDate?.[1]).toISOString()
          : ""
        : null,
      type: type,
    };
    postCoursePlanSearchAppraisal(data)
      .then((res) => {
        const { data } = res.data;
        if (type) {
          setTotalRecordsApprove(res.data.data.totalRecords);
          setListCourseApproval(data.data);
        } else {
          setTotalRecordsSubmit(res.data.data.totalRecords);
          setListCourse(data.data);
          setListCourseMany(data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getDataResetSearch = (type: boolean) => {
    setLoading(true);
    const data = {
      keyword: searchValue,
      pageNumber: pageNumber,
      pageSize: pageSize,
      individualId: userId,
      submitedDateFrom: !isEmpty(filterData.submissionDate?.[0])
        ? new Date(filterData.submissionDate?.[0]).toISOString()
        : "",
      submitedDateTo: !isEmpty(filterData.submissionDate?.[1])
        ? new Date(filterData.submissionDate?.[1]).toISOString()
        : "",
      approvalDateFrom: type
        ? !isEmpty(filterData.approvalDate?.[0])
          ? new Date(filterData.approvalDate?.[0]).toISOString()
          : ""
        : null,
      approvalDateTo: type
        ? !isEmpty(filterData.approvalDate?.[1])
          ? new Date(filterData.approvalDate?.[1]).toISOString()
          : ""
        : null,
      type: type,
    };
    postCoursePlanSearchAppraisal(data)
      .then((res) => {
        const { data } = res.data;
        if (type) {
          setTotalRecordsApprove(res.data.data.totalRecords);
          setListCourseApproval(data.data);
        } else {
          setTotalRecordsSubmit(res.data.data.totalRecords);
          setListCourse(data.data);
          setListCourseMany(data.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const handleListCourse = () => {
    getData(true);
    getData(false);
  };
  useEffect(() => {
    setPageNumber(1);
    setPageSize(10);
    getDataResetSearch(false);
    getDataResetSearch(true);
  }, [activeTabKey]);

  useEffect(() => {
    // setSearchValue("");
    if (activeTabKey === "1") {
      getDataResetSearch(false);
    } else {
      getDataResetSearch(true);
    }
  }, [pageNumber, pageSize]);
  const locale = {
    emptyText: (
      <span>
        <p>
          <img
            className="image-empty-data"
            src="/images/empty-img-gray.png"
            alt="empty-img"
          ></img>
        </p>
        <p className="nodata-text">
          {t("Không tìm kết quả với từ khoá", "Không tìm kết quả với từ khoá")} "{searchValueNotFound}"
        </p>
      </span>
    ),
    triggerDesc: t("Sắp xếp theo thứ tự Z-A", "Sắp xếp theo thứ tự Z-A"),
    triggerAsc: t("Sắp xếp thứ tự A-Z", "Sắp xếp thứ tự A-Z"),
    cancelSort: t("Huỷ sắp xếp", "Huỷ sắp xếp"),
  };
  const itemsTab: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <div>
          <span>{t("Chờ thẩm định", "Chờ thẩm định")} </span>
          <span className="border-total-record">{totalRecordsSubmit}</span>
        </div>
      ),
      children: (
        <div className="waiting-assignment">
          <TableWaitAppraisalPlan
            locale={locale}
            totalRecords={totalRecordsSubmit}
            pageSize={pageSize}
            listCourse={listCourse}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            handleListCourse={handleListCourse}
            loading={loading}
            activeTabKey={activeTabKey}
          />
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div>
          <span>{t("Đã thẩm định", "Đã thẩm định")} </span>
          <span className="border-total-record">{totalRecordsApprove}</span>
        </div>
      ),
      children: (
        <div className="assigned">
          <TableAppraisalPlan
            locale={locale}
            totalRecords={totalRecordsApprove}
            listCourseApproval={listCourseApproval}
            pageSize={pageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            activeTabKey={activeTabKey}
          />
        </div>
      ),
    },
  ];
  const clearFilter = () => {
    form.resetFields();
    setFilterData({
      submissionDate: null,
      approvalDate: null,
    });
    setLoading(true);
    if (activeTabKey === "1") {
      const data = {
        keyword: "",
        pageNumber: pageNumber,
        pageSize: pageSize,
        individualId: userId,
        submitedDateFrom: null,
        submitedDateTo: null,
        approvalDateFrom: null,
        approvalDateTo: null,
        type: false,
      };
      postCoursePlanSearchAppraisal(data)
        .then((res) => {
          const { data } = res.data;
          setTotalRecordsSubmit(res.data.data.totalRecords);
          setListCourse(data.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      const data = {
        keyword: "",
        pageNumber: pageNumber,
        pageSize: pageSize,
        individualId: userId,
        submitedDateFrom: null,
        submitedDateTo: null,
        approvalDateFrom: null,
        approvalDateTo: null,
        type: true,
      };
      postCoursePlanSearchAppraisal(data)
        .then((res) => {
          const { data } = res.data;
          setTotalRecordsSubmit(res.data.data.totalRecords);
          setListCourse(data.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  const OpenManyApprovalsSurvey = () => {
    setIsOpenManyApprovalsSurvey(true);
  };
  const handleCloseManyApprovalsSurvey = () => {
    setIsOpenManyApprovalsSurvey(false);
  };
  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
  };
  const handleChangeFilter = (value: any, name: string) => {
    setFilterData({ ...filterData, [name]: value });
  };
  const handleSubmitSearch = () => {
    setSearchValueNotFound(searchValue);
    setPageNumber(1);
    setPageSize(10);
    if (activeTabKey === "1") {
      getData(false);
    } else {
      getData(true);
    }
  };
  const handleSearchEnter = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      handleSubmitSearch();
    }
  };
  return (
    <Layout className="page-header-group course-construction">
      <Form.Provider>
        <div className="table-header--wrapper">
          <FilterAppraisalPlan
            title={title}
            form={form}
            clearFilter={clearFilter}
            activeTabKey={activeTabKey}
            searchValue={searchValue}
            handleChangeInput={handleChangeInput}
            filterData={filterData}
            setFilterData={handleChangeFilter}
            handleSubmitSearch={handleSubmitSearch}
            handleSearchEnter={handleSearchEnter}
            handleOpenManyApprovalsSurvey={OpenManyApprovalsSurvey}
          />
        </div>
        <div className="tabs-heading">
          <Tabs
            items={itemsTab}
            activeKey={activeTabKey}
            onChange={(key) => setActiveTabKey(key)}
          />
        </div>
        <ManyApprovalsSurvey
          listCourse={listCourseMany}
          open={isOpenManyApprovalsSurvey}
          handleCancel={() => {
            handleCloseManyApprovalsSurvey();
          }}
        />
      </Form.Provider>
    </Layout>
  );
};

export default AppraisalPlanList;
